module.exports = __webpack_public_path__ + "img/product2.5807cb45.jpg";